export default {
  // Breakpoint pixels
  screenXsMax: 599,
  screenSmMin: 600,
  screenSmMax: 767,
  screenMdMin: 768,
  screenMdMax: 959,
  screenLgMin: 960,
  screenLgMax: 1199,
  screenXlMin: 1200,

  // Spacing
  spacingHero: 80,
  spacingSuperMassive: 64,
  spacingMassive: 48,
  spacingXLarge: 32,
  spacingLarge: 24,
  spacingMedium: 16,
  spacingSmall: 12,
  spacingTiny: 8,
  spacingMini: 4,
  spacingMicro: 2,

  // Sizes
  fontSizeHero: 128,
};
